import React, { useState } from 'react';
import Navbar from '../../../Components/Navbar';
import { toast } from 'react-toastify';
import { Create_Api } from '../../../API/Api_Url';
import { useNavigate, useParams } from 'react-router-dom';

function SignUp() {
    const navigate = useNavigate()
    const { id } = useParams()
    const [IsUploading, setIsUploading] = useState(false);
    const [Role, setRole] = useState('');
    const [SubRole, setSubRole] = useState('');
    const [companyName, setcompanyName] = useState('');
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [Number, setNumber] = useState('');
    const [City, setCity] = useState('');
    const [Location, setLocation] = useState('');
    const [AcceptedTerms, setAcceptedTerms] = useState(false);

    const RoleOptions = [
        { value: '', label: 'Select Role' },
        { value: 'Contractor', label: 'Contractor' },
        { value: 'Supplier', label: 'Supplier' },
        { value: 'Freelance', label: 'Freelance' },
        { value: 'Labour', label: 'Labour' },
    ];

    const ContractorRole = [
        'Building Plan Approval Consultant',
        'Civil Contractor (Main)',
        'Labor Supply Contractor',
        'Aluminium / UPVC Window Vendor',
        'Ready Mix Concrete Supplier',
        'Borewell Contractor',
        'Waterproofing Specialist',
        'Scaffolding Contractor/centring',
        'False Ceiling Contractor',
        'Smart Home Automation Expert',
        'CCTV & Security System Installer',
        'Solar Panel /Green Energy Installer',
        'Generator/Inverter Vendor',
        'Signage Board',
        'Electricity Meter Sanction Expert',
        'Water Connection Approval Expert'
    ];

    const SupplierRole = [
        'Brick / Block Supplier',
        'Steel Supplier',
        'Cement & Aggregate Vendor',
        'Sand & Gravel Supplier',
        'JCB / Excavation Contractor',
        'Water Tanker Supplier',
        'Lift Vendor'
    ];

    const FreelanceRole = [
        'Land Surveyor',
        'Environmental Clearance Consultant',
        'Architect',
        'Structural Design Engineer(steel Str)',
        'RCC Design Engineer',
        'Electrical Design Engineer',
        'Plumbing Design Engineer',
        'HVAC Design Engineer',
        'Interior Designer',
        'Landscape Architect',
        'Vastu Consultant',
        'AR/VR House Demo Consultant',
        'Fire Safety NOC Consultant',
        'Project Management Consultant (PMC)',
        'Soil Testing Consultant / Geotechnical Engineer',
        'PSC design Engineer',
        'Rainwater Harvesting Consultant',
        'Registered Building Valuator (Chartered Engineer)',
        'Bank Loan Agents',
        '3D Visualizer / Walkthrough Specialist',
        'CADD Engineer / Draftsman',
        'Quantity Surveyor (QS)Estimation & BOQ ',
        'Site Engineer / Supervisor'
    ];

    const LabourRole = [
        'Bar Bender / Steel Fixing Team',
        'Carpenter',
        'Plumber',
        'Electrician',
        'Welder / Fabricator'
    ];

    const getSubRoleOptions = () => {
        switch (Role) {
            case 'Contractor': return ContractorRole;
            case 'Supplier': return SupplierRole;
            case 'Freelance': return FreelanceRole;
            case 'Labour': return LabourRole;
            default: return [];
        }
    };

    const roleConfig = {
        Contractor: {
            endpoint: 'api/contractor/register',
            keys: {
                name: 'name',
                companyName: 'companyName',
                email: 'email',
                password: 'password',
                phone: 'phone'
            }
        },
        Supplier: {
            endpoint: 'api/material-supplier/register',
            keys: {
                name: 'contactPerson',
                companyName: 'companyName',
                email: 'emailAddress',
                password: 'password',
                phone: 'phoneNumber'
            }
        },
        Freelance: {
            endpoint: 'api/freelance-engineer/register',
            keys: {
                name: 'fullName',
                companyName: 'companyName',
                email: 'emailAddress',
                password: 'password',
                phone: 'phoneNumber'
            }
        },
        Labour: {
            endpoint: 'api/labour/register',
            keys: {
                name: 'fullName',
                companyName: 'companyName',
                email: 'emailAddress',
                password: 'password',
                phone: 'phoneNumber'
            }
        }
    };

    const [errors, setErrors] = useState({});
    const validateForm = () => {
        const newErrors = {};

        if (!Role) newErrors.Role = 'Please select a role.';
        if (!Name) newErrors.Name = 'Name is required.';
        if (!Number) newErrors.Number = 'Phone number is required.';
        else if (!/^\d{10}$/.test(Number)) newErrors.Number = 'Mobile number must be exactly 10 digits.';
        if (!AcceptedTerms) newErrors.AcceptedTerms = 'Please accept the Terms and Conditions.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSignup = async () => {

        try {
            if (validateForm()) {
                const selectedConfig = roleConfig[Role];
                if (!selectedConfig) return toast.error('Invalid Role selected');

                const { endpoint, keys } = selectedConfig;

                const data = {
                    [keys.name]: Name,
                    [keys.companyName]: companyName,
                    [keys.email]: Email,
                    [keys.password]: Number,
                    [keys.phone]: Number,
                    SubRole: SubRole,
                    Location: Location,
                    City: City,
                    ...(id && { ReferCode: id })
                };

                setIsUploading(true);

                const response = await Create_Api(endpoint, data);

                console.log('Signup Successful:', response?.data);
                toast.success(response?.message);
                setRole('')
                setcompanyName('');
                setName('');
                setEmail('');
                setNumber('');
                setSubRole('');
                setLocation('');
                setCity('');
                navigate('/');
                setTimeout(() => window.location.reload(), 3000);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };

    const countryCodes = [
        { code: "+91", label: "India" },
        { code: "+1", label: "USA" },
        { code: "+44", label: "UK" },
        { code: "+61", label: "Australia" },
        { code: "+81", label: "Japan" },
    ];



    return (
        <>
            <Navbar />
            <div className="signup-container">
                <div className="signup-form">
                    <h3 className="signup-title">Sign Up</h3>
                    <p className="signup-subtitle">
                        Join our network of construction professionals and connect with clients.
                    </p>

                    <label className="signup-label">Role</label>
                    <select
                        name="Role"
                        value={Role}
                        onChange={(e) => { setRole(e.target.value) }}
                        className="signup-select"
                    >
                        {RoleOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {errors?.Role && <span className="error-text">{errors?.Role}</span>}
                    {Role && getSubRoleOptions().length > 0 && (
                        <>
                            <label className="signup-label">Role Type</label>
                            <select
                                name="SubRole"
                                value={SubRole}
                                onChange={(e) => setSubRole(e.target.value)}
                                className="signup-select"
                            >
                                <option value="">Select Role Type</option>
                                {getSubRoleOptions().map((role, index) => (
                                    <option key={index} value={role}>{role}</option>
                                ))}
                            </select>
                        </>
                    )}


                    <label className="signup-label">Company Name</label>
                    <input
                        type="text"
                        name="companyName"
                        value={companyName}
                        onChange={(e) => { setcompanyName(e.target.value) }}
                        className="signup-input"
                    />
                    <label className="signup-label">Name</label>
                    <input
                        type="text"
                        name="name"
                        value={Name}
                        onChange={(e) => { setName(e.target.value) }}
                        className="signup-input"
                    />
                    {errors?.Name && <span className="error-text">{errors?.Name}</span>}

                    <label className="signup-label">Email</label>
                    <input
                        type="email"
                        name="email"
                        value={Email}
                        onChange={(e) => { setEmail(e.target.value) }}
                        className="signup-input"
                    />

                    {/* <label className="signup-label">Phone Number</label>
                    <input
                        type="number"
                        name="Number"
                        value={Number}
                        onChange={(e) => { setNumber(e.target.value) }}
                        className="signup-input no-spinner"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') e.preventDefault();
                        }}
                    /> */}
                    <>
                        <label className="signup-label">Phone Number</label>
                        <div className="phone-input-wrapper">
                            <select
                                className="country-code-dropdown"
                            // value={selectedCode}
                            // onChange={(e) => setSelectedCode(e.target.value)}
                            >
                                {countryCodes.map((country) => (
                                    <option key={country.code} value={country.code}>
                                        {country.label} ({country.code})
                                    </option>
                                ))}
                            </select>
                            <input
                                type="number"
                                name="Number"
                                value={Number}
                                onChange={(e) => { setNumber(e.target.value) }}
                                className="signup-input no-spinner phone-input"
                                placeholder="Enter 10-digit number"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") e.preventDefault();
                                }}
                            />
                        </div>
                    </>
                    {errors?.Number && <span className="error-text">{errors?.Number}</span>}
                    <label className="signup-label">City</label>
                    <input
                        type="text"
                        name="City"
                        value={City}
                        onChange={(e) => { setCity(e.target.value) }}
                        className="signup-input"
                    />
                    <label className="signup-label">Pincode</label>
                    <input
                        type="number"
                        name="Location"
                        value={Location}
                        onChange={(e) => { setLocation(e.target.value) }}
                        className="signup-input no-spinner"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') e.preventDefault();
                        }}
                    />
                    <div className="signup-terms">
                        <input
                            type="checkbox"
                            id="terms"
                            checked={AcceptedTerms}
                            onChange={(e) => setAcceptedTerms(e.target.checked)}
                        />
                        <label htmlFor="terms" className="signup-label" style={{ marginLeft: '8px' }}>
                            I accept the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                        </label>
                    </div>
                    {errors?.AcceptedTerms && <span className="error-text">{errors?.AcceptedTerms}</span>}

                    <button
                        onClick={() => { handleSignup() }}
                        className="signup-button"
                        disabled={IsUploading}
                    >
                        {IsUploading ? (
                            <span className="loader"></span>
                        ) : (
                            'Submit'
                        )}
                    </button>

                </div>
            </div>
        </>
    );
}

export default SignUp;
